import memoryAxiosInstance from '../../../core/api/memoryAxios';

export const dashboardService = {
  getWeekChart: async (userUuid: string, week: number) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/dashboard/${userUuid}/week-chart`,
      {
        params: { week },
      }
    );
    return response.data;
  },
  getDifficultyLevel: async (userUuid: string) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/dashboard/${userUuid}/difficulty-level`
    );
    return response.data;
  },
  getRadialStatusChart: async (userUuid: string) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/dashboard/${userUuid}/radial-status`
    );
    return response.data;
  },
};
